import { Response } from '@/types';
import { ResponseStatus } from '@/constants/ajax';
export class CancelledResponse implements Response {
    public readonly status: ResponseStatus;
    public readonly reason: Reason;

    constructor(reason: Reason) {
        this.reason = reason;
        this.status = ResponseStatus.CANCELLED;
    }
}

export enum Reason {
    RACE = 'race',
}
